var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0082de;}.b{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-251 17.805)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(251 -17.805)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(259.65 -10.011)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.316,38.318a.527.527,0,0,0-.472.676,8.5,8.5,0,0,1,.3,2.241,8.762,8.762,0,0,1-14.088,6.9l2.163-.255a.527.527,0,0,0-.124-1.046l-3.356.4a.528.528,0,0,0-.464.586.474.474,0,0,0,.008.048l.729,3.37a.534.534,0,0,0,1.044-.223l-.406-1.862A9.823,9.823,0,0,0,37.2,41.234a9.574,9.574,0,0,0-.332-2.521.529.529,0,0,0-.505-.4Z",
    transform: "translate(-17.571 -30.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.422,6a.528.528,0,0,0-.493.562.52.52,0,0,0,.02.113L24.5,8.7A9.832,9.832,0,0,0,9,16.655a9.505,9.505,0,0,0,.332,2.5.53.53,0,0,0,1.041-.2.517.517,0,0,0-.022-.08,8.43,8.43,0,0,1-.29-2.225,8.772,8.772,0,0,1,14.229-6.8l-2.378.4a.527.527,0,1,0,.105,1.05.508.508,0,0,0,.069-.011l3.456-.577a.528.528,0,0,0,.434-.608c0-.017-.007-.034-.011-.051L24.977,6.4a.529.529,0,0,0-.505-.4Z",
    transform: "translate(-9 -6.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.b97de8d322ec125f6d766917ac0172e2.svg";
export { ForwardRef as ReactComponent };